import { useNavigate } from "react-router-dom";
import mensajeError from "../mensajes/MensajeError";

export default function VerificarUsuario() {
    const navigate = useNavigate();
    fetch("/api/usuario/usuario", {
        headers: { "Content-Type": "application/json" },
        credentials: "include"
    })
        .then(responseUsuario => {
            if (responseUsuario.ok) return responseUsuario.json();
            mensajeError("Página no autorizada");
            navigate("/login");
        })
        .then(data => {
            if (data.status !== "OK") {
                mensajeError("Página no autorizada");
                navigate("/login");
            }

        })
}